<template>
  <section class="reset">
    <section v-if="!noTitle" class="contents__header--top account_child">
      <h2 class="contents__header--subtitle">{{ $t("reset.title") }}</h2>
    </section>
    <section class="contents__body">
      <section class="contents__section">
        <dl class="item__block">
          <dt class="item__block--label">{{ $t("reset.present_pw") }}</dt>
          <dd class="item__block--value">
            <div class="password-field">
              <input maxlength="20"
                :type="showCurrentPassword ? 'text' : 'password'"
                v-model="params.current_password"
                @blur="checkError('current_password', params.current_password)">
              <button type="button" class="toggle-password"
                @click="showCurrentPassword = !showCurrentPassword"
                :aria-label="showCurrentPassword ? 'Hide password' : 'Show password'">
                <i
                  :class="showCurrentPassword ? 'far fa-eye' : 'far fa-eye-slash'"></i>
              </button>
            </div>
            <p v-if="error.current_password" class="error__txt">
              {{ error.current_password }}</p>
          </dd>
        </dl>
        <dl class="item__block new_pw">
          <dt class="item__block--label">{{ $t("reset.new_pw") }}</dt>
          <dd class="item__block--value">
            <div class="password-field">
              <input maxlength="20"
                :type="showNewPassword ? 'text' : 'password'"
                v-model="params.user.password"
                @blur="checkError('new_password', params.user.password)"
                autocomplete="new-password">
              <button type="button" class="toggle-password"
                @click="showNewPassword = !showNewPassword"
                :aria-label="showNewPassword ? 'Hide new password' : 'Show new password'">
                <i
                  :class="showNewPassword ? 'far fa-eye' : 'far fa-eye-slash'"></i>
              </button>
            </div>
            <ul class="helper">
              <li :class="isPass.length ? 'pass' : ''">{{
                $t("helper.char_length") }}
              </li>
              <li :class="isPass.char ? 'pass' : ''">{{ $t("helper.char") }}
              </li>
              <li :class="isPass.special ? 'pass' : ''">
                <span class="helper__text"
                  v-html="$t('helper.special_chars', { chars: '~!@#$^&*()_+' })"></span>
              </li>
              <li v-if="error.sequential" class="error_txt">
                {{ $t("helper.sequence") }}
              </li>
              <li v-if="error.repeated" class="error_txt">
                {{ $t("helper.repeat") }}
              </li>
              <li v-if="error.userid" class="error_txt">
                {{ $t("helper.userid") }}
              </li>
              <li v-if="error.invalid" class="error_txt">
                <span class="helper__text"
                  v-html="$t('helper.invalid_chars', { chars: '~!@#$^&*()_+' })"></span>
              </li>
            </ul>
          </dd>
        </dl>
        <dl class="item__block">
          <dt class="item__block--label">
            {{ $t("reset.new_pw") }}{{ $t("reset.confirm") }}
          </dt>
          <dd class="item__block--value">
            <div class="password-field">
              <input maxlength="20"
                :type="showConfirmPassword ? 'text' : 'password'"
                v-model="params.user.password_confirmation"
                autocomplete="new-password"
                @blur="checkError('confirm', params.user.password_confirmation)">
              <button type="button" class="toggle-password"
                @click="showConfirmPassword = !showConfirmPassword"
                :aria-label="showConfirmPassword ? 'Hide password' : 'Show password'">
                <i
                  :class="showConfirmPassword ? 'far fa-eye' : 'far fa-eye-slash'"></i>
              </button>
            </div>
            <p v-if="error.confirm" class="error__txt">{{ error.confirm }}</p>
          </dd>
        </dl>

        <p v-if="error.update" class="error__txt fail">
          {{ $t("reset.update_error") }}</p>
        <div class="bts-block bts">
          <button @click="resetData()" class="bt--reset">
            <span id="btn_save_reset">{{ $t("bts.reset") }}</span></button>
          <button
            v-if="params.current_password && params.user.password && params.user.password_confirmation"
            @click="updatePassword" class="bt--submit">
            <span id="btn_save__save">{{ $t("bts.change") }}</span></button>
          <button v-else disabled class="bt--submit">
            <span id="btn_save__save">{{ $t("bts.change") }}</span></button>
        </div>
      </section>
    </section>
  </section>
</template>

<script>
import { displayGuide } from "@/shared"
import BtnSave from "@/components/AppBtnSave"

export default {
  name: "Reset",
  props: {
    noTitle: {
      type: Boolean,
      default: false
    }
  },
  mixins: [displayGuide],
  components: {
    BtnSave
  },
  data() {
    return {
      isError: true,
      showCurrentPassword: false,
      showNewPassword: false,
      showConfirmPassword: false,
      params: {
        current_password: null,
        user: {
          password: null,
          password_confirmation: null
        }
      },
      error: {
        update: false,
        char: false,
        length: false,
        special: false,
        userid: false,
        sequential: false,
        repeated: false,
        confirm: false
      },
      isPass: {
        char: false,
        length: false,
        special: false
      },
      errorCount: 0
    }
  },
  created() {
    this.params.lang = this.lang || localStorage.selectLang;
  },
  computed: {
    lang() {
      return this.$store.state.locales.locale;
    }
  },
  watch: {
    "params.current_password": {
      handler(e) {
        this.error.current_password = false
        this.error.update = false
      }
    },
    "params.user.password": {
      handler(e) {
        this.error.update = false
        this.checkNewPassword(e)
      }
    },
    "params.user.password_confirmation": {
      handler(e) {
        this.error.update = false
        this.error.confirm = false
      }
    },
    "lang": {
      handler(e) {
        this.params.lang = e
      }

    }
  },
  //半角英数文字　8-20文字、~ ! @ # $ ^ & * ( ) _ +　?

  methods: {
    // ログアウト処理をメッセージ表示も含めて集約
    logout(isForced = false) {
      // 3秒後にデータクリアとログアウト
      setTimeout(() => {
        // メッセージを表示
        this.$emit("result", {
          name: "reset",
          check: !isForced
        });

        // さらに3秒後にデータクリアとログアウト
        setTimeout(() => {
          // パスワード変更データをクリア
          this.resetData();
          localStorage.clear();
          window.location.href = '/';
        }, 3000);
      }, 0);
    },

    // エラーカウント処理
    handleError() {
      this.errorCount++;
      if (this.errorCount >= 6) {
        this.logout(true); // 強制ログアウトフラグを追加
      }
    },

    updatePassword() {
      if (this.params.user.password != this.params.user.password_confirmation) {
        this.error.confirm = this.$t("error.notmatch");
        return;
      }

      this.$store
        .dispatch("auths/resetPasswordAction", this.params)
        .then(e => {
          if (e.status == 200) {
            this.logout(false); // 成功時のログアウト
          } else if (e.response?.status == 422 && e.response.data.message.includes("Current password")) {
            this.error.update = true;
            this.handleError();
          } else {
            this.$emit("result", { name: "reset", check: false });
            this.handleError();
          }
        })
        .catch(() => {
          this.$emit("result", { name: "reset", check: false });
          this.handleError();
        });
    },

    resetData() {
      this.params = {
        current_password: null,
        user: {
          password: null,
          password_confirmation: null
        },
        lang: this.lang
      };

      // エラー状態もリセット
      this.error = {
        current_password: false,
        update: false,
        char: false,
        length: false,
        special: false,
        sequential: false,
        repeated: false,
        confirm: false
      };

      this.isPass = {
        char: false,
        length: false,
        special: false
      }

      // パスワード表示状態もリセット
      this.showCurrentPassword = false;
      this.showNewPassword = false;
      this.showConfirmPassword = false;

      // エラーカウントもリセット
      this.errorCount = 0;
    },
    checkNewPassword(data) {
      if (!data) {
        return;
      }

      data = data.trim();

      // 長さチェック（8-20文字）
      this.isPass.length = data.length >= 8 && data.length <= 20;

      // 文字種チェック
      const hasUpperCase = /[A-Z]/.test(data);
      const hasLowerCase = /[a-z]/.test(data);
      const hasNumbers = /[0-9]/.test(data);
      this.isPass.char = hasUpperCase && hasLowerCase && hasNumbers;

      // 特殊文字チェック
      const allowedSpecialChars = /^[\~\!@\#\$\^\&\*\(\)\_\+\?A-Za-z0-9]+$/;
      const hasSpecialChars = /[\~\!@\#\$\^\&\*\(\)\_\+\?]/.test(data);
      this.isPass.special = hasSpecialChars;

      // 許可されていない文字のチェック
      this.error.invalid = !allowedSpecialChars.test(data);

      // 連続文字チェック
      // const hasSequential = /abc|bcd|cde|def|efg|fgh|ghi|hij|ijk|jkl|klm|lmn|mno|nop|opq|pqr|qrs|rst|stu|tuv|uvw|vwx|wxy|xyz/i.test(data) ||
      //   /012|123|234|345|456|567|678|789/.test(data);
      // this.error.sequential = hasSequential;

      // 同じ文字の繰り返しチェック
      // this.error.repeated = /(.)\1{2,}/.test(data);

      // ユーザーIDと同じパスワードのチェック
      const userId = localStorage.userid;
      this.error.userid = data.includes(userId);
    },
    checkError(name, data) {
      if (name == 'current_password') {
        this.error[name] = data == null ? this.$t("error.input") : null
      } else if (name == 'confirm') {
        this.params.user.password == data ? this.error.confirm = null : this.error.confirm = this.$t("error.notmatch")
      } else if (name == 'new_password') {
        if (data == null) {
          this.error[name] = this.$t("error.input")
          return
        }
        this.checkNewPassword(data)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.reset {
  .fail {
    text-align: center;
  }

  .item__block {
    align-items: flex-start;
  }

  .item__block--label {
    @media (min-width:561px) {
      line-height: 27px;
    }
  }

  .item__block--value {
    width: 70%;

    @media (max-width:560px) {
      width: 100%;
      margin-top: .5rem;

      .helper {
        font-size: 1.2rem;
      }
    }
  }

  .password-field {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;

    input {
      flex: 1;
      padding-right: 40px;
    }

    .toggle-password {
      position: absolute;
      right: 10px;
      background: none;
      border: none;
      cursor: pointer;
      padding: 5px;
      color: #666;

      &:hover {
        color: #333;
      }
    }
  }

  .helper {
    li {
      color: #777;

      &::before {
        content: '\f0c8';
        font-family: 'Font Awesome 5 Free';
        padding-right: 5px;
      }

      &.pass,
      &.error_txt {
        &::before {
          content: '\f14a';
        }
      }

      &.pass {
        color: #24a186;
      }
    }

    :deep(.green) {
      color: #24a186;
      font-weight: 700;
      letter-spacing: 0.2rem;
    }

    .error_txt {
      color: #ff0000;
    }

  }
}
</style>
